import React, {useState, useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import DatePicker, {registerLocale} from "react-datepicker";
import ApiService from "../../util/ApiService";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import HospitalSearch from "../../hospital/HospitalSearch";
import LoadingScreen from "../../util/LoadingScreen";
import Select from "react-select";
import AuthService from "../../util/AuthService";
import UsersSearch from "./UsersSearch";
import InputMask from "react-input-mask";
import Skeleton from "react-loading-skeleton";

// Registrar locale pt-BR
registerLocale("pt-BR", ptBR);

const ScaleModal = ({show, handleClose, handleSubmit, scale, filters}) => {
    const user = AuthService.getUserData();
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [statusEditValue, setStatusEditValue] = useState(true);

    const [scaleData, setScaleData] = useState({
        id: null,
        order_month: "",
        department_id: "",
        duty_scale_day_wee_id: "",
        hospital_id: "",
        users_id: "",
        company_id: "",
        date_start: new Date(),
        date_end: null,
        time_begin: "",
        time_end: "",
        value: "",
        observation: "",
        total_hours: "00:00"
    });
    const [loading, setLoading] = useState(false);
    const [hospitalOptions, setHospitalOptions] = useState(null); // Ajuste para suportar o hospital inicial
    const [userOptions, setUserOptions] = useState(null);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]);


    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S',
                filter_manager: user?.users_type_id == 1 ? 1 : 0,
            }, true);
            const {data} = ApiService.handleApiResponse(response);
            const options = data.map(department => ({
                value: department.id,
                label: department.name,
                hourly_rate: department.value,
            }));

            setDepartmentOptions(options);

        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const fetchScaleData = async (id) => {
        setLoadingSearch(true);
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}scale/onerecord/${id}`, null, true);

            const {data} = ApiService.handleApiResponse(response);

            const fetchedScale = data;

            setScaleData({
                id: fetchedScale.id ?? "",
                order_month: fetchedScale.order_month ?? "",
                duty_scale_day_wee_id: fetchedScale.duty_scale_day_wee_id ?? "",
                hospital_id: fetchedScale.hospital_id ?? "",
                users_id: fetchedScale.users_id ?? "",
                department_id: fetchedScale.department_id ?? "",
                company_id: fetchedScale.company_id ?? "",
                date_start: fetchedScale.date_start ? new Date(fetchedScale.date_start) : null,
                date_end: fetchedScale.date_end && fetchedScale.date_end !== '2500-01-01' ? new Date(fetchedScale.date_end) : null,
                time_begin: fetchedScale.time_begin ? fetchedScale.time_begin.slice(0, 5) : "",
                time_end: fetchedScale.time_end ? fetchedScale.time_end.slice(0, 5) : "",
                value: fetchedScale.value ?? "",
                observation: fetchedScale.observation ?? "",
                total_hours: fetchedScale.total_hours ?? "00:00",
                hourly_rate: parseFloat(fetchedScale?.hospital_user?.value)
            });

            // Configurar hospital inicial
            setHospitalOptions(
                fetchedScale.hospital
                    ? {
                        id: fetchedScale.hospital.id,
                        name: fetchedScale.hospital.name,
                        city_name: fetchedScale.hospital.city_name || fetchedScale.hospital.city?.name,
                        uf: fetchedScale.hospital.uf || fetchedScale.hospital.city?.uf,
                    }
                    : null
            );


            const initialUser = fetchedScale.user
                ? {
                    id: fetchedScale.user.id,
                    name: fetchedScale.user.name,
                    cpf: fetchedScale.user.cpf || '',
                    city: fetchedScale.user.city,
                    state: fetchedScale.user.state,
                }
                : null;


            setUserOptions(
                fetchedScale.user
                    ? {
                        id: fetchedScale.user.id,
                        name: fetchedScale.user.name,
                        cpf: fetchedScale.user.cpf || '',

                    }
                    : null
            );

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };

    const onHospitalSelect = (hospital) => {
        // Atualiza hospital selecionado e redefine o inicial

        if (hospital) {


            const departmentRate = parseFloat(scaleData.department?.hourly_rate || 0);
            const hospitalRate = parseFloat(hospital?.hourly_rate || 0);
            const finalRate = departmentRate > 0 ? departmentRate : hospitalRate;

            console.log('hospitalRate', hospitalRate);
            console.log('departmentRate', departmentRate);
            console.log('finalRate', finalRate);

            setScaleData((prev) => ({
                ...prev,
                hospital_id: hospital?.value || null,
                hospital: hospital,
                hourly_rate: finalRate
            }));


            if (parseFloat(hospital?.hourly_rate) > 0) {
                setStatusEditValue(true);
            } else {
                setStatusEditValue(false);
            }

        } else {
            setStatusEditValue(false);
            setScaleData({
                ...scaleData,
                hospital_id: null,
                hospital: null,
                hourly_rate: parseFloat(scaleData.department?.hourly_rate || 0)
            });
        }

    };


    const onUserSelect = (users) => {

        setScaleData({...scaleData, users_id: users?.value || null});

        if (users?.due_date && users.due_date) {
            const dueDate = new Date(users.due_date); // Converte a string em uma instância de Date
            setScaleData((prevState) => ({...prevState, date_end: dueDate}));
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessages([]);


        const formattedScale = {
            ...scaleData,
            value: parseFloat(scaleData.value),
        };


        const apiEndpoint = scale?.id ? `${process.env.REACT_APP_URL_API}scale/update` : `${process.env.REACT_APP_URL_API}scale/register`;
        const method = scale?.id ? "put" : "post";

        try {
            const response = await ApiService.send(method, apiEndpoint, formattedScale, true);
            const {data} = ApiService.handleApiResponse(response); // <-- aqui você extrai o retorno completo da API

            Swal.fire({
                title: "Sucesso!",
                text: scale?.id ? "Escala atualizada com sucesso!" : "Escala registrada com sucesso!",
                icon: "success",
                confirmButtonText: "OK",
            }).then(() => {
                handleClose(true, data); // envia para a listagem a escala atualizada
            });

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchDepartment();
        if (show && scale?.id) {
            fetchScaleData(scale.id);
        } else if (show) {
            setScaleData({
                lunch_time: "00:00",
                order_month: filters?.order_month || null,
                duty_scale_day_wee_id: "",
                hospital_id: "",
                userOptions: null,
                users_id: "",
                company_id: "",
                date_start: new Date(),
                date_end: null,
                time_begin: "",
                time_end: "",
                value: "",
                observation: "",
                total_hours: "00:00"
            });

            setHospitalOptions(null);
            setCompanyOptions([]);
        }
    }, [show]);

    useEffect(() => {
        if (scaleData?.hourly_rate) {
            const totalHoras = scaleData.total_hours;

            let horas = 0;
            if (typeof totalHoras === "string" && totalHoras.includes(":")) {
                const [h, m] = totalHoras.split(":").map(Number);
                horas = h + m / 60;
            } else {
                horas = parseFloat(totalHoras);
            }

            const valor = parseFloat((parseFloat(scaleData.hourly_rate || 0) * horas).toFixed(2));


            setScaleData((prev) => ({
                ...prev,
                value: valor
            }));
        }else{
            setScaleData((prev) => ({
                ...prev,
                value: 0
            }));
        }
    }, [scaleData.total_hours, scaleData.hourly_rate]);


    const [calculatedEndTime, setCalculatedEndTime] = useState("");

    useEffect(() => {
        if (!scaleData.time_begin || !scaleData.total_hours) {
            setCalculatedEndTime("");
            return;
        }

        const [startHour, startMinute] = scaleData.time_begin.split(":").map(Number);
        const [durationHour, durationMinute] = scaleData.total_hours.split(":").map(Number);

        const startDate = new Date();
        startDate.setHours(startHour, startMinute, 0, 0);

        const endDate = new Date(startDate);
        endDate.setHours(endDate.getHours() + durationHour);
        endDate.setMinutes(endDate.getMinutes() + durationMinute);

        const isNextDay = endDate.getDate() !== startDate.getDate();

        const formatted = endDate.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });

        setCalculatedEndTime(`${formatted}${isNextDay ? " (+1 Dia)" : ""}`);
    }, [scaleData.time_begin, scaleData.total_hours]);


    const handleDepartmentSelect = (selectedOption) => {
        const updatedDepartment = selectedOption || null;

        const departmentRate = parseFloat(selectedOption?.hourly_rate || 0);
        const hospitalRate = parseFloat(scaleData.hospital?.hourly_rate || 0);
        const finalRate = departmentRate > 0 ? departmentRate : hospitalRate;


        setScaleData((prev) => ({
            ...prev,
            department_id: updatedDepartment?.value || null,
            department: updatedDepartment,
            hourly_rate: finalRate,
        }));
    };



    return (
        <>

            <Modal show={show} onHide={handleClose} centered size={"lg"}>
                <Modal.Header closeButton>
                    <Modal.Title>{scale?.id ? "Editar Escala" : "Registrar Escala"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-6 form-group">
                                <label>Ordem da Semana</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (

                                    <select
                                        className="form-control"
                                        value={scaleData.order_month}
                                        onChange={(e) => setScaleData({...scaleData, order_month: e.target.value})}
                                    >
                                        <option value="" disabled>
                                            Selecione a semana
                                        </option>
                                        <option value="0">Toda Semana</option>
                                        <option value="1">1ª Semana</option>
                                        <option value="2">2ª Semana</option>
                                        <option value="3">3ª Semana</option>
                                        <option value="4">4ª Semana</option>
                                        <option value="5">5ª Semana</option>
                                    </select>
                                )}
                            </div>
                            <div className="col-6 form-group">
                                <label>Dia da Semana</label>

                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <select
                                        className="form-control"
                                        value={scaleData.duty_scale_day_wee_id}
                                        onChange={(e) =>
                                            setScaleData({...scaleData, duty_scale_day_wee_id: e.target.value})
                                        }
                                    >
                                        <option value="" disabled>
                                            Dia da semana
                                        </option>
                                        <option value="0">Domingo</option>
                                        <option value="1">Segunda-Feira</option>
                                        <option value="2">Terça-Feira</option>
                                        <option value="3">Quarta-Feira</option>
                                        <option value="4">Quinta-Feira</option>
                                        <option value="5">Sexta-Feira</option>
                                        <option value="6">Sábado</option>
                                    </select>
                                )}
                            </div>

                            <div className="col-6 form-group">
                                {loadingSearch ? (
                                    <>
                                        <label>Local</label>
                                        <Skeleton height={38} width="100%" borderRadius={6}/>
                                    </>
                                ) : (

                                    <HospitalSearch
                                        buttonAdd={false}
                                        cache={false}
                                        inicialEditable={true}
                                        onHospitalSelect={onHospitalSelect}
                                        initialHospital={hospitalOptions}
                                        validateManager={true}
                                    />
                                )}
                            </div>
                            <div className="col-6 form-group">
                                <label>Departamento</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <Select
                                        isClearable={true}
                                        value={departmentOptions.find(option => option.value === scaleData.department_id) || null} // Define valor inicial
                                        onChange={handleDepartmentSelect}
                                        options={departmentOptions}
                                        placeholder="Selecione o departamento"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                )}
                            </div>


                            <div className="col-6 form-group">
                                {loadingSearch ? (
                                    <>
                                        <label>Usuário</label>
                                        <Skeleton height={38} width="100%" borderRadius={6}/>
                                    </>

                                ) : (
                                    <UsersSearch
                                        departmentId={scaleData?.department_id}
                                        situation="accepted"

                                        buttonAdd={false}
                                        onUserSelect={onUserSelect}
                                        initialUser={userOptions}
                                    />
                                )}
                            </div>
                            <div className="col-3 form-group">
                                <label>Carga Horária</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={scaleData.total_hours}
                                        onChange={(e) => setScaleData({...scaleData, total_hours: e.target.value})}
                                    />
                                )}
                            </div>
                            <div className="col-3 form-group">
                                <label>Tempo de Intervalo</label>

                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                <input
                                    type="time"
                                    className="form-control"
                                    value={scaleData.lunch_time || "00:00"}
                                    onChange={(e) => {
                                        const value = e.target.value; // valor no formato HH:mm
                                        setScaleData((prev) => ({
                                            ...prev,
                                            lunch_time: value,
                                        }));
                                    }}
                                    style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                />
                                )}

                            </div>
                            <div className="col-3 form-group">
                                <label>Horário de Início</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={scaleData.time_begin}
                                        onChange={(e) => setScaleData({...scaleData, time_begin: e.target.value})}
                                    />
                                )}

                            </div>
                            <div className="col-3 form-group">
                                <label>Horário de Término</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <span className="form-control bg text-dark"
                                          style={{backgroundColor: "#e9ecef", opacity: 1}}>
                                        {calculatedEndTime || "--:--"}
                                    </span>
                                )}

                            </div>
                            <div className="col-6 form-group">
                                <label>Valor</label>
                                {loadingSearch ? (
                                    <Skeleton height={38} width="100%" borderRadius={6}/>
                                ) : (
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={
                                            scaleData.value !== undefined && scaleData.value !== null
                                                ? Number(scaleData.value).toFixed(2).replace('.', ',')
                                                : '0,00'
                                        }
                                        placeholder="Valor"
                                        disabled={true}
                                    />
                                )}

                            </div>
                        </div>
                        <div className="form-group">
                            <label>Observação</label>
                            {loadingSearch ? (
                                <Skeleton height={38} width="100%" borderRadius={6}/>
                            ) : (
                                <textarea
                                    className="form-control"
                                    value={scaleData.observation}
                                    onChange={(e) => setScaleData({...scaleData, observation: e.target.value})}
                                    placeholder="Observação"
                                />
                            )}
                        </div>
                        {errorMessages.length > 0 && (
                            <div className="alert alert-danger mt-3">
                                <ul>
                                    {errorMessages.map((error, index) => (
                                        <li key={index}>{error}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <div className="modal-footer">
                            <button type="button" className="btn  btn-dark mt-3"
                                    onClick={() => handleClose()}
                            >
                                <i className="fa fa-close me-1"></i> Fechar
                            </button>
                            <button type="submit" className="btn btn-info mt-3" disabled={loading}>
                                {loading ? (
                                    <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                        Salvando...
                                    </>
                                ) : (
                                    <>
                                        <i className={`fa ${scale?.id ? 'fa-sync-alt' : 'fa-plus'} me-2`}></i>
                                        {scale?.id ? "Atualizar Escala" : "Registrar Escala"}
                                    </>
                                )}
                            </button>

                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
        ;
};

export default ScaleModal;
